export default {
    PtSliderRange: {
        invalidTip: '無效數據或超出數據范圍',
    },
};
